// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__12pua","tableContainer":"styles_tableContainer__2XuYj","giniIndexInfo":"styles_giniIndexInfo__3t-hR"};